const REFERRAL_STORAGE_KEY = 'referral_code';
const REFERRAL_TTL_MS = 14 * 24 * 60 * 60 * 1000;

const clearLegacyReferralKeys = () => {
  localStorage.removeItem('promotekit_referral');
  localStorage.removeItem('referral_via');
};

export const setReferralCode = referralCode => {
  if (!referralCode) return;

  const payload = {
    value: referralCode,
    expiresAt: Date.now() + REFERRAL_TTL_MS,
  };

  localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(payload));
  clearLegacyReferralKeys();
};

export const getReferralCode = () => {
  const raw = localStorage.getItem(REFERRAL_STORAGE_KEY);
  if (!raw) return '';

  try {
    const parsed = JSON.parse(raw);
    if (!parsed?.value || !parsed?.expiresAt) {
      localStorage.removeItem(REFERRAL_STORAGE_KEY);
      return '';
    }

    if (Date.now() > parsed.expiresAt) {
      localStorage.removeItem(REFERRAL_STORAGE_KEY);
      return '';
    }

    return parsed.value;
  } catch (error) {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
    return '';
  }
};

export const clearReferralCode = () => {
  localStorage.removeItem(REFERRAL_STORAGE_KEY);
  clearLegacyReferralKeys();
};
